"use client";
import useClientTranslations from "@casino/client/hooks/useClientTranslations";
import SharedGameBadge from "@casino/shared/components/GameBadge";
import getBadge from "@casino/shared/components/GameBadge/helpers/getBadge";
import {
  GAME_BADGE_TRANSLATION_KEYS,
  type GameCardTranslations,
} from "@casino/shared/components/GameCard/translations";

type Props = {
  game: GameFragment;
  translations?: GameCardTranslations;
};

const GameBadge: FC<Props> = ({ game, translations: initialTranslations }) => {
  const translations = useClientTranslations(
    GAME_BADGE_TRANSLATION_KEYS,
    initialTranslations,
  );
  const badge = getBadge(game);

  if (!badge) {
    return null;
  }

  return (
    <SharedGameBadge badge={badge}>
      {translations?.[badge.translationKey]}
    </SharedGameBadge>
  );
};

export default GameBadge;
